import {useQuery} from "@tanstack/react-query";
import {fetchGraphQL} from "../../../utils/gql-utils";
import {getGraphQLUrl} from "../../../web3/apollo/client";
import { mapTxType, txFragmentV3 } from "./transactions.utils";

export const useGetTransactionsV3Data = (enabled?: boolean, full?: boolean) => {
  const query = useQuery({
    queryKey: ["transactions-v3", full],
    queryFn: async () => {
      const url = getGraphQLUrl(true);
      return await fetchGraphQL(
        url,
        `
        query {
          transactions(first: ${full ? 100 : 20}, orderBy: timestamp, orderDirection: desc) {
            id
            mints(orderBy: timestamp, orderDirection: desc) {
              ${txFragmentV3('mint')}
            }
            burns(orderBy: timestamp, orderDirection: desc) {
              ${txFragmentV3('burn')}
            }
            swaps(orderBy: timestamp, orderDirection: desc) {
              ${txFragmentV3('swap')}
            }
          }a
        }
      `,
      ).then(({data}: {data: {transactions: (Record<string, any[]> & {id: string})[]}}) =>
        data.transactions
          .map((t) => {
            const {mints, burns, swaps, id} = t;
            return [...mapTxType("mints", mints), ...mapTxType("burns", burns), ...mapTxType("swaps", swaps)]
              .map((_, i) => ({..._, hash: id, index: i}));
          })
          .flat(),
      );
    },
    enabled,
    refetchOnWindowFocus: false,
  });

  return {
    ...query,
    txs: query.data || [],
  };
};
